import React from 'react';
import ActionSheet from "actionsheet-react";
import {Button} from '../index';
import {connect} from "react-redux";

class ActionSheetComponent extends React.Component {
    constructor(props) {
        super(props);

        this.ref = React.createRef();
    }

    componentDidUpdate(prevProps) {
        const {show} = this.props;
        if (show !== prevProps.show) {
            this.handleShowChange(show);
        }
    }

    handleShowChange(show) {
        if (show) {
            this.handleOpen();
        } else {
            this.handleClose();
        }
    }

    handleOpen = () => {
        this.ref.current.open();
    };

    handleClose = () => {
        this.callback();
        this.ref.current.close();
    };

    callback = () => {
        this.props.callback(false);
    };

    render() {
        const {sheetStyle, bgStyle, children, hasClose} = this.props;

        const _sheetStyle = Object.assign({paddingBottom: 20}, sheetStyle);

        const {locale} = this.props;
        const pageTranslates = locale.translation.Components.ActionSheet;

        return (
            <ActionSheet
                ref={this.ref}
                onClose={this.callback}
                sheetStyle={_sheetStyle}
                bgStyle={bgStyle}>
                <div style={{
                    height: 6,
                    width: 50,
                    margin: '0 auto',
                    borderRadius: 10,
                    marginTop: 12,
                    marginBottom: 12,
                    cursor: 'move',
                }} className='bg-primary'/>

                <div style={{padding: 10}}>
                    {children}
                </div>

                {hasClose &&
                <>
                    <div className="divider" style={{margin: 0}}></div>
                    <div style={{padding: 10}}>
                        <Button title={pageTranslates.Cancel} onClick={this.handleClose} type='primary' shadowType='lg' full/>
                    </div>
                </>
                }
            </ActionSheet>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(ActionSheetComponent);

